
import { mapState, mapActions } from "vuex";
import backButtonFullHeight from "../common/back-button-full-height.vue";
export default {
  components: { backButtonFullHeight },
  name: "userLogin",
  data() {
    return {
      loading: false,
      valid: false,
      formError: "",
      hasLocationSelectorError: false,
      glocation: {
        formatted_address: ""
      },
      locationRule: [(v) => !!v || "Location is required"],
      brands: [],
      business: {},
      location: {}
    };
  },
  props: {
    businessProp: {
      type: Object,
      default: {}
    },
    hasMultipleBrands: {
      type: Boolean,
      default: false
    }
  },

  beforeMount() {
    this.business = JSON.parse(JSON.stringify(this.businessProp));
    this.location = JSON.parse(
      JSON.stringify(this.businessProp.locations_attributes[0])
    );
    if (!this.location.restaurants_attributes.length) {
      this.populateBrand();
    }
  },

  methods: {
    validateForm() {
      this.valid = this.$refs.form.validate();
    },
    getAddressData(data) {
      this.hasLocationSelectorError = false;
      this.valid = true;
      // this.location.restaurants_attributes[0].name;
      this.glocation = data;
      this.location.name = data.formatted_address;
      this.location.address = data.name;
      this.location.latitude = data.geometry.location.lat();
      this.location.longitude = data.geometry.location.lng();
      const zipCodeFound = data.address_components.find((el) => {
        return Number(el.long_name) !== NaN && el.types[0] === "postal_code";
      });
      if (zipCodeFound) {
        this.location.zip_code = zipCodeFound.long_name;
      }
    },

    handleLocationError() {
      const el = document.getElementById("gmap-autocomplete");
      if (!el.value) {
        this.location.name = "";
      } else {
        el.value = this.location.name;
      }
      if (
        this.business.locations_attributes &&
        this.location.name &&
        this.location.name !== ""
      ) {
        this.hasLocationSelectorError = false;
        // el.classList.remove("error-border");
        return true;
      } else {
        this.hasLocationSelectorError = true;
        // el.classList.add("error-border");
        this.valid = false;
        return false;
      }
    },

    submitForm() {
      this.validateForm();
      this.handleLocationError();
      if (this.valid) {
        this.business.locations_attributes[0] = this.location;
        this.$emit("submit-restaurant-form", this.business);
      }
    },
    populateBrand() {
      this.location.restaurants_attributes.push({
        name: ""
      });
    },
    deleteBrand(index) {
      this.location.restaurants_attributes.splice(index, 1);
    }
  }
};
